import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';

export type UiStandaloneTabId = number | string;

export interface UiStandaloneTab {
    id: UiStandaloneTabId;
    label: string;
    disabled?: boolean;
    hidden?: boolean;
    failure?: boolean;
    elementCount?: number;
}

@Component({
    styleUrls: ['./ui-standalone-tabs.scss'],
    selector: 'ui-standalone-tabs',
    templateUrl: 'ui-standalone-tabs.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiStandaloneTabsComponent {
    options = input<UiStandaloneTab[]>();
    selectedTabId = model.required<UiStandaloneTabId>();
    divider = input(true);

    visibleOptions = computed(() => this.options()?.filter(option => !option.hidden) ?? []);
}
